import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { User } from '../../../_models/user.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Constants } from '../../constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  userId = null;
  userName = '';
  userRole = '';

  constructor(private authService: AuthenticationService,
    private router: Router) { }

  ngOnInit() {
    this.authService.currentUser.subscribe(user => {
      if (user) {
        this.userId = user.userId;
        this.userName = user.firstName + ' ' + user.lastName;
        this.userRole = user.roleTypeDesc;
        console.log('UserName: ' + this.userName);
      }
    });

    const currentUser: User = JSON.parse(
      sessionStorage.getItem(Constants.AUTH_TOKEN));
    if (currentUser) {
      this.userId = currentUser.userId;
      this.userName = currentUser.firstName + ' ' + currentUser.lastName;
      this.userRole = currentUser.roleTypeDesc;
    }
  }
}
